import { Flex, Alert, AlertIcon, Text, Link } from '@chakra-ui/core';
import HybridImage from "../../../../src/components/HybridImage";
import hashingSrc from '@/assets/images/hashing.png';
import flowSrc from '@/assets/images/flow.png';
import * as React from 'react';
export default {
  Flex,
  Alert,
  AlertIcon,
  Text,
  Link,
  HybridImage,
  hashingSrc,
  flowSrc,
  React
};